import { AISummary } from '@statsbomb/kitbag-ai-summary';
import { NoTextLoader } from '@/components/contentState/NoTextLoader';
import { useSummaryPlayerData } from '@/hooks/useSummaryPlayerData';

export const PlayerDashboardSummaryContent = () => {
  const playerData = useSummaryPlayerData();
  if (!playerData) return <NoTextLoader />;

  return (
    <div className="h-full overflow-y-auto">
      {/* There is pre-existing custom styling within this project. Follow up required to handle styling inside component library */}
      <AISummary key={playerData.playerId} playerData={playerData} />
    </div>
  );
};
